<template>
  <div class="main">
    <div>
      <div class="operation">
        <el-button @click="$router.go(-1)">返回</el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="detailData"
        border
        style="width: 100%"
      >
        <el-table-column prop="contact_name" label="姓名"></el-table-column>
        <el-table-column prop="username" label="手机号"></el-table-column>
        <el-table-column prop="vip_start_time" label="开始时间">
          <template slot-scope="sopce">{{
            sopce.row.vip_start_time == "1970-01-01"
              ? ""
              : sopce.row.vip_start_time
          }}</template>
        </el-table-column>
        <el-table-column prop="vip_end_time" label="结束时间">
          <template slot-scope="sopce">{{
            sopce.row.vip_end_time == "1970-01-01" ? "" : sopce.row.vip_end_time
          }}</template>
        </el-table-column>
        <el-table-column
          prop="industry_data.first_industry_name"
          label="所属行业"
        ></el-table-column>
        <el-table-column
          prop="license_company_name"
          label="公司名称"
        ></el-table-column>
        <el-table-column label="注册用户状态">
          <template>
            <div v-if="!registration_status">未审核</div>
            <div v-else>{{ registration_status == 1 ? "不通过" : "通过" }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="sales_personnel_mobile"
          label="销售人员手机号"
        ></el-table-column>
        <el-table-column label="营业执照图片">
          <template>
            <el-image
              style="width: 40px; height: 30px"
              :src="url"
              :preview-src-list="srcList"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width>
          <template slot-scope="scope">
            <el-button
              v-if="registration_status === 0"
              @click.stop="HandleClick(scope.row, scope.row.id)"
              type="text"
              size="small"
              >审核成功</el-button
            >
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              v-if="registration_status === 0"
              @click.stop="errClick(scope.row, scope.row.id)"
              type="text"
              size="small"
              >审核失败</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";

export default {
  data() {
    return {
      detailData: [],
      loading: true,
      url: "",
      srcList: [],
      registration_status: 0,
    };
  },
  created() {
    this.init();
  },
  mounted() {},

  methods: {
    init() {
      let obj = {
        username: this.$route.query.id,
      };
      require("post", "/hr24_user/v1/user_register_detail/", obj).then(
        (res) => {
          if (!res.code) {
            console.log(res);
            this.detailData = res.data;
            this.loading = false;
            this.srcList[0] = res.data[0].license;
            this.url = res.data[0].license;
            this.registration_status = res.data[0].registration_status;
          } else {
          }
        }
      );
    },
    Imagepic(row, url) {},
    HandleClick(row, id) {
      console.log(row, id);
      this.allmethods(id, 2);
    },
    errClick(row, id) {
      console.log(row, id);
      this.allmethods(id, 1);
    },

    allmethods(id, status) {
      console.log(id, status);
      let obj = {
        register_id: id,
        registration_status: status,
      };
      require("post", "/hr24_user/v1/user_check/", obj).then((res) => {
        if (!res.code) {
          console.log(res);
          this.init();
          this.$message({
            message: res.msg,
            type: "success",
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
.main {
  margin-top: 46px;
  margin-left: 229px;
  background: #ffff;
  min-height: 80vh;
  width: 80vw;

  border-radius: 4px;
  box-shadow: 1px 1px 12px rgb(211, 210, 210);
  padding: 50px;
}
.operation {
  padding: 12px;
}
</style>



// WEBPACK FOOTER //
// src/sales_management/auit_detail.vue